import {
  VeticAuthAPIS,
  VeticBookingAPIS,
  VeticCBLAPIS,
  VeticCartModuleAPIS,
  VeticCertificateDocumentModuleAPIS,
  VeticClinicAPIS,
  VeticConfigurationAPIS,
  VeticCouponServiceAPIS,
  VeticCustomerAPIS,
  VeticEMRAPIS,
  VeticGeoAPIS,
  VeticInventoryModuleAPIS,
  VeticInvoiceAPIS,
  VeticPetInsuranceAPIS,
  VeticLabReportListAPIS,
  VeticMembershipExtensionModuleAPIS,
  VeticMembershipModuleAPIS,
  VeticNudgesAPIS,
  VeticDayClosingAPIS,
  VeticOrdersAPIS,
  VeticOrgAPIS,
  VeticPatientWaitingListAPIS,
  VeticPaymentModuleAPIS,
  VeticPetsAPIS,
  VeticQuickCommerceAPIS,
  VeticRotaAPIS,
  VeticServiceDeskAPI,
  VeticSlotsAPIS,
  VeticStaffCalendarAPIS,
  VeticStaticAPIS,
  VeticUserAPIS,
  VeticVoucherAPIS,
  VeticWhitelistNumberModuleAPIS,
  VeticToolsModuleAPIS,
  VeticExotelAPIS,
  VeticMappingAPIS,
  VeticTilesModuleAPIS,
} from "./interface";

/* DEV APIS loaded from env files  */

const BASE_URL = import.meta.env.VITE_BASE_URL;
const BASE_IAM_URL = import.meta.env.VITE_IAM_URL;
const BASE_IAM_ORG_URL = `${BASE_URL}/iam-service`;
const BASE_BOOKING_URL = import.meta.env.VITE_BOOKING_BASE_URL;
const BASE_QC_URL = import.meta.env.VITE_QC_BASE_URL;
const BASE_MEMBERSHIP_URL = import.meta.env.VITE_MEMBERSHIP_URL;
const BASE_USER_PROFILE_URL = import.meta.env.VITE_USER_PROFILE_URL;
const BASE_STATIC_API = import.meta.env.VITE_STATIC_API;
const BASE_QC_ORDER = import.meta.env.VITE_QC_ORDER_URL;
const BASE_QC_COUPON = import.meta.env.VITE_QC_COUPON_URL;
const BASE_CART_URL = import.meta.env.VITE_CART_URL;
const BASE_PAYMENT_URL = import.meta.env.VITE_PAYMENT_URL;
const BASE_VMS_MEMBERSHIP_URL = import.meta.env.VITE_VMS_MEMBERSHIP_URL;
const BASE_VETIC_NEEV_URL = import.meta.env.VITE_VETIC_NEEV_URL;
const BASE_VETIC_LOG_URL = import.meta.env.VITE_VETIC_CLICK_LOG_URL;
const SOCKET_API = import.meta.env.VITE_SOCKET_URL;
const ORDER_CANCEL_ON_PARTNER_URL = import.meta.env.VITE_DELIVERY_URL;
const EXOTEL_CALL_CONNECT_URL = import.meta.env.VITE_LEAD_URL;
const BASE_MUNI_URL = import.meta.env.VITE_BASE_MUNI_URL;

export const EXOTEL_APIS: VeticExotelAPIS = {
  EXOTEL_CALL_DETAILS: {
    baseURL: `${BASE_MUNI_URL}/ameyo/v1/user-call-details`,
    params: {},
  },
  EXOTEL_CALL_DISPOSITION: {
    baseURL: `${BASE_MUNI_URL}/ameyo/v1/call-disposition`,
    params: {},
  },
  EXOTEL_MANUAL_CALL_INIT: {
    baseURL: `${BASE_MUNI_URL}/ameyo/v1/manual-call-init`,
    params: {},
  },
  EXOTEL_CONTEXT_ENGINE: {
    baseURL: `${BASE_VETIC_NEEV_URL}/context-engine/v1/context/`,
    params: {},
  },
  EXOTEL_BULK_CART_UPDATE: {
    baseURL: `${BASE_CART_URL}/hd/cart/bulk-cart-update`,
    params: {},
  },
};

export const NUDGES_APIS: VeticNudgesAPIS = {
  NUDGES_ALERT: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/v1/nudges/list/`,
    params: {},
  },
  SOCKET_APIS: {
    baseURL: `${SOCKET_API}`,
    params: {},
  },
  NUDGES_ACTION: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/v1/nudges/comments`,
    params: {},
  },
  NUDGES_ADD_FOOD_MEDICINE: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/v1/nudges/add-item-to-emr/`,
    params: {},
  },
  NUDGES_ADD_FOOD_MEDICINE_INCART: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/v1/nudges/add-to-cart/`,
    params: {},
  },
  NUDGES_TELECONSULTATION_ESCALATION_TICKET: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/v1/nudges/create_escalation_ticket`,
    params: {},
  },
};

export const DAY_CLOSING_APIS: VeticDayClosingAPIS = {
  CASH_CLOSING_LIST: {
    baseURL: `${BASE_PAYMENT_URL}/v1/day-closing/finance/cms-transactions`,
    params: {},
  },
  DAY_CLOSING_SUMMARY: {
    baseURL: `${BASE_PAYMENT_URL}/v1/day-closing/summary`,
    params: {},
  },
  DAY_CLOSING_CURRENT_SHIFT: {
    baseURL: `${BASE_PAYMENT_URL}/v1/day-closing/current-shift`,
    params: {},
  },
  CASH_CLINIC_WALLET_DETAILS: {
    baseURL: `${BASE_PAYMENT_URL}/v1/day-closing/finance/clinic-wallets`,
    params: {},
  },
  CMS_TRANSACTIONS: {
    baseURL: `${BASE_PAYMENT_URL}/v1/day-closing/finance/cms-transactions`,
    params: {},
  },
  CMS_CASH_REPORT: {
    baseURL: `${BASE_PAYMENT_URL}/v1/day-closing/finance/cash-report`,
    params: {},
  },
  CASH_SORTAGE_API: {
    baseURL: `${BASE_PAYMENT_URL}/v1/day-closing/finance/shortage-requests`,
    params: {},
  },
  APPOITNTMENT_STATUS: {
    baseURL: `${BASE_PAYMENT_URL}/v1/day-closing/`,
    params: {},
  },
  DAY_CLOSING_RECEVING: {
    baseURL: `${BASE_PAYMENT_URL}/v1/day-closing/operations/reconciliation/receiving`,
    params: {},
  },
  PAYMENT_OVERDUE: {
    baseURL: `${BASE_PAYMENT_URL}/v1/day-closing/appointments/reconciliation/payment`,
    params: {},
  },
  OVERDUE_REASONS: {
    baseURL: `${BASE_PAYMENT_URL}/v1/vms/payments/overdue-invoice-reasons`,
    params: {},
  },
  SERVICE_INVOICES: {
    baseURL: `${BASE_PAYMENT_URL}/v1/day-closing/appointments/reconciliation/service_invoices`,
    params: {},
  },
  VIDEO_CONSULTATION: {
    baseURL: `${BASE_PAYMENT_URL}/v1/day-closing/appointments/reconciliation/videoconsultation_bookings`,
    params: {},
  },
  VIDEO_CONSULTATION_COMPLETE: {
    baseURL: `${BASE_PAYMENT_URL}/v1/day-closing/appointments/reconciliation/complete_videoconsultation_booking`,
    params: {},
  },
  OPEN_CART: {
    baseURL: `${BASE_PAYMENT_URL}/v1/day-closing/appointments/reconciliation/open_carts`,
    params: {},
  },
};

export const VOUCHER_APIS: VeticVoucherAPIS = {
  VOUCHER_LIST: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/v1/voucher/families/list`,
    params: {},
  },
  VOUCHER_CREATE: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/v1/voucher/families`,
    params: {},
  },
  VOUCHER_CATEGORY_SUB_CATEGORY: {
    baseURL: `${BASE_URL}/clinic-org/vms/voucher/category-subcategory/`, // GET
    params: {},
  },
};
export const PETS_APIS: VeticPetsAPIS = {
  SINGLE_PET: {
    baseURL: `${BASE_URL}/clinic-org/vms/pet/`,
    params: {},
  },
  UPDATE_PET: {
    baseURL: `${BASE_URL}/clinic-org/vms/pet/`,
    params: {},
  },
  CREATE_PET: {
    baseURL: `${BASE_URL}/clinic-org/vms/pet/`,
    params: {},
  },
  LIST_PETS: {
    baseURL: `${BASE_URL}/clinic-org/vms/pet/`,
    params: {},
  },
  BREED_LIST: {
    baseURL: `${BASE_URL}/clinic-org/pet-breeds/`,
    params: {},
  },
};
export const STATIC_APIS: VeticStaticAPIS = {
  PET_GENDERS: {
    baseURL: `${BASE_URL}/clinic-org/pet-genders/`,
    params: {},
  },
  ADDRESS_LABELS: {
    baseURL: `${BASE_IAM_URL}/iam/address-labels/`,
    params: {},
  },
  PET_MOODS: {
    baseURL: `${BASE_URL}/clinic-org/vms/pet-mood/`,
    params: {},
  },
  PET_STATUSES: {
    baseURL: `${BASE_URL}/clinic-org/vms/pet-status/`,
    params: {},
  },
  PET_SPECIES: {
    baseURL: `${BASE_URL}/clinic-org/pet-species/`,
    params: {},
  },
};

export const GEO_APIS: VeticGeoAPIS = {
  OPEN_STREET: {
    baseURL: `${BASE_URL}/hd_orders/location/search/vms/`,
    params: {},
  },
  SEARCH: {
    baseURL: `${BASE_URL}/hd_orders/location/search/vms/`,
    params: {},
  },
};

export const USER_APIS: VeticUserAPIS = {
  USER_ROLE: {
    baseURL: `${BASE_IAM_URL}/iam/central/user-roles/`,
    params: {},
  },
  USER_CREADIT: {
    baseURL: `${BASE_URL}/clinic-org/vetbuddy/client-credit-memo/`,
    params: {},
  },
};

export const BOOKING_APIS: VeticBookingAPIS = {
  PROFILE_PIN_ELIGIBILITY: {
    baseURL: `${BASE_URL}/booking/users/`,
    params: {},
  },
  LIST_BOOKINGS: {
    baseURL: `${BASE_URL}/booking/vms/user-bookings/`,
    params: {},
  },
  PAYMENT_HISTORY: {
    baseURL: `${BASE_URL}/booking/vms/payment-history/`,
    params: {},
  },
  BOOKING_HISTORY: {
    baseURL: `${BASE_URL}/booking/vms/history/`,
    params: {},
  },
  SEND_SCRIPT: {
    baseURL: `${BASE_BOOKING_URL}/whatsapp/script/`,
    params: {},
  },
  LIST_STATUSES: {
    baseURL: `${BASE_BOOKING_URL}/v3/vms/patient-waiting-list/booking-statuses/`,
    params: {},
  },
  APPOINTMENT_COUNT: {
    baseURL: `${BASE_URL}/booking/vms/booking-detail-count/`,
    params: {},
  },
  APPOINTMENT_REFUND_INITIATE: {
    baseURL: `${BASE_BOOKING_URL}/payment/manual-refund/`,
    params: {},
  },
  APPOINTMENT_REFUND_DETAILS: {
    baseURL: `${BASE_URL}/booking/payment/refund/customer-details/`,
    params: {},
  },
  CHECK_REFUND_STATUS: {
    baseURL: `${BASE_BOOKING_URL}/payment/manual-refund/status-check/`,
    params: {},
  },
  FREE_FOLLOW_UP: {
    baseURL: `${BASE_QC_URL}/v3/alerts/`,
    params: {},
  },
  BOOKING_TELECONSULTATION: {
    baseURL: `${BASE_BOOKING_URL}/teleconsultation/bd-slot-booking/`,
    params: {},
  },
  BOOKING_TELECONSULTATION_SCRIPT: {
    baseURL: `${BASE_URL}/booking/teleconsultation/bd-slot-booking-script/`,
    params: {},
  },
  SMART_QC_DEEPLINK_CARDS: {
    baseURL: `${BASE_VETIC_NEEV_URL}/smart-qc-deeplink/cards/`,
    params: {},
  },
  SMART_QC_DEEPLINK_SCRIPT: {
    baseURL: `${BASE_VETIC_NEEV_URL}/smart-qc-deeplink/script/`,
    params: {},
  },
  SMART_QC_DEEPLINK_SEND: {
    baseURL: `${BASE_VETIC_NEEV_URL}/smart-qc-deeplink/send/`,
    params: {},
  },
  CLINIC_LOCATION_WHATSAPP_SCRIPT: {
    baseURL: `${BASE_VETIC_NEEV_URL}/clinic-location/script/`,
    params: {},
  },
  CLINIC_LOCATION_WHATSAPP_SEND: {
    baseURL: `${BASE_VETIC_NEEV_URL}/clinic-location/send/`,
    params: {},
  },
  AHS_BOOKING_LINK_SCRIPT: {
    baseURL: `${BASE_VETIC_NEEV_URL}/ahs-booking-link/script/`,
    params: {},
  },
  AHS_BOOKING_LINK_SEND: {
    baseURL: `${BASE_VETIC_NEEV_URL}/ahs-booking-link/send/`,
    params: {},
  },
};

export const CUSTOMER_APIS: VeticCustomerAPIS = {
  CUSTOMER_SYNC: {
    baseURL: `${BASE_URL}/clinic-org/vms/customer-sync/details/`,
  },
  SEND_OTP: {
    baseURL: `${BASE_IAM_URL}/iam/vms/send-otp/`,
  },
  OTP_VERIFICATION: {
    baseURL: `${BASE_IAM_URL}/iam/vms/verify-otp/`,
  },
  VERIFY_PIN: {
    baseURL: `${BASE_IAM_URL}/iam/vms/verify-pin/`,
  },
  SEND_PIN_WHATSAPP: {
    baseURL: `${BASE_IAM_URL}/iam/vms/send-profile-pin/`,
  },
  MOBILE_VALIDATION: {
    baseURL: `${BASE_IAM_URL}/iam/vms/numbervalidation/`,
  },
  PERSONA_CREATION_API: {
    baseURL: `${BASE_IAM_URL}/user/persona/details/`,
  },
  PERSONA_DETAILS_API: {
    baseURL: `${BASE_IAM_URL}/user/persona/details/`, // GET <user_id> (no trailing slash)
  },
  CHECK_CALL_BUTTON_STATUS: {
    baseURL: `${BASE_USER_PROFILE_URL}/check-call-button/`,
  },
  EXOTEL_CONNECT_USER_PROFILE: {
    baseURL: `${EXOTEL_CALL_CONNECT_URL}/lead/exotel/call/connect-user-profile`,
  },
  ADD_ADDRESS: {
    baseURL: `${BASE_IAM_URL}/iam/vms/address/`,
    params: {},
  },
  USER_PROFILE: {
    baseURL: `${BASE_USER_PROFILE_URL}/user-detail/`,
    params: {},
  },
  TELECONSULTATION: {
    baseURL: `${BASE_USER_PROFILE_URL}/call/`,
    params: {},
  },
  CLINICMANAGER_MOBILE: {
    baseURL: `${BASE_STATIC_API}/api/clinic-manager-mobiles`,
    params: {},
  },
  MEMBERSHIP_STATIC_LIST: {
    baseURL: `${BASE_STATIC_API}/api/website/membership-sales-dashboard`,
    params: {},
  },
  SEARCH_CUSTOMER: {
    baseURL: `${BASE_IAM_ORG_URL}/iam/vms/search-customer/`,
    params: {},
  },
  CUSTOMER_DETAILS: {
    baseURL: `${BASE_IAM_URL}/iam/vms/customer/detail/`,
    params: {},
  },
  UPDATE_CUSTOMER: {
    baseURL: `${BASE_IAM_URL}/iam/vms/customer/profile/update/`,
    params: {},
  },
  CREATE_CUSTOMER: {
    baseURL: `${BASE_IAM_URL}/iam/vms/customer/`,
    params: {},
  },
  MEMBERSHIP_DETAILS: {
    baseURL: `${BASE_MEMBERSHIP_URL}/api/membership/utilization/`,
    params: {},
  },
  VACCINATION_DETAILS: {
    baseURL: `${BASE_URL}/clinic-org/vms/vaccination/`,
    params: {},
  },
  MEDICAL_HISTORY_DETAILS: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/medicine-history/`,
  },
  VACCINATION_OCR: {
    baseURL: `${BASE_URL}/vaccine-data/vaccination-record-file-upload/`,
    params: {},
  },
  VACCINATION_SINGLE_GET: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vaccination/vaccination_ocr_data/`,
    params: {},
  },
  PET_WISE_VACCINATION: {
    baseURL: `${BASE_URL}/vaccine-data/user_vaccination_data/`,
    params: {},
  },
  VACCINATION_OCR_UPDATE: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vaccination/update-user-vaccination-data-ocr`,
    params: {},
  },
  VACCINATION_DATA_RECORD: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vaccination/update-vaccination-data/`,
    params: {},
  },
  VACCINATION_DATA_DELETION: {
    baseURL: `${BASE_URL}/vaccine-data/save_user_vaccine_records/`,
    params: {},
  },
  VACCINATION_UPCOMING_LIST: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vaccination/vaccination-schedule/`,
    params: {},
  },
  VACCINATION_UPDATE: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vaccination/update-vaccination-data/`,
    params: {},
  },
  VACCINATION_DOB_BREED_SPECIES_UPDATE: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vaccination/update-pet-dob/`,
    params: {},
  },
  VACCINATION_HISTORY_LIST: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vaccination/vaccination-status/`,
    params: {},
  },
  VACCINATION_INPUT_LIST: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vaccination/vaccination-input/`,
    params: {},
  },
  VACCINATION_SUMMARY_LIST: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vaccination/vaccination-summary/`,
    params: {},
  },
  VACCINATION_REMINDER_LIST: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vaccination/vaccination-reminder/`,
    params: {},
  },
  VACCINATION_REMINDERS: {
    baseURL: `${BASE_VETIC_NEEV_URL}/reminders/pet-wise-list`,
    params: {},
  },
  AI_PET_PROFILE_FOR_CUSTOMER: {
    baseURL: `${BASE_VETIC_NEEV_URL}/iam/v1/ai-pet-profile/customer/`,
    params: {},
  },
  AI_PET_PROFILE_FOR_PET: {
    baseURL: `${BASE_VETIC_NEEV_URL}/iam/v1/ai-pet-profile/pets/`,
    params: {},
  },
};

export const EMR_APIS: VeticEMRAPIS = {
  VB_EMR_API: {
    baseURL: `${BASE_QC_URL}/soap-notes/`,
  },
  PET_BODY_DENTAL_SCORE: {
    baseURL: `${BASE_URL}/clinic-org/vms/v2/emr/static/bcs-ds/`,
  },
  EMR_TEMPLATE_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/v2/emr/static/emr-type/`,
  },
  EMR_DOWNLOAD_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/generate-pdf/`,
  },
  DOWNLOAD_EMR_PDF_API: {
    baseURL: `${BASE_URL}/clinic-org/v2/vms/emr/generate-pdf/`,
  },
  CREATE_EMR: {
    baseURL: `${BASE_URL}/clinic-org/vms/v2/emr/create/`,
  },
  DIAGNOSIS_DATA: {
    baseURL: `${BASE_URL}/clinic-org/vms/v2/emr/static/diagnosis/`,
  },
  GET_EMR_USER_AND_PET: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/`,
    params: {
      user_id: "",
      pet_id: "",
    },
  },
  GET_EMR_DETAILS_V2: {
    baseURL: `${BASE_URL}/clinic-org/vms/v2/emr/detail/`,
  },
  UPDATE_EMR_V2: {
    baseURL: `${BASE_URL}/clinic-org/vms/v2/emr/update/`,
  },
  EMR_CLINIC_CONFIG: {
    baseURL: `${BASE_URL}/clinic-org/vms/v2/emr/clinic-config/`,
  },
  GET_SINGLE_EMR: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/detail/`,
  },
  UPDATE_EMR: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/detail/`,
  },
  SECTION_SEARCH: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/search/v2/`,
  },
  LIST_EMRS: {
    baseURL: `${BASE_URL}/clinic-org/user-emr/`,
    params: {},
  },
  LATEST_EMRS_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/v2/emr/list/`,
    params: {},
  },
  LAB_TEST: {
    baseURL: `${BASE_URL}/clinic-org/vms/pet-documents/`,
    params: {},
  },
  STATIC_DURATION: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/static/duration/`,
  },
  STATIC_FREQUENCY: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/static/frequency/`,
  },
  STATIC_MEDICINE_FREQUENCY: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/static/medicine-frequency/`,
  },
  STATIC_ROUTES: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/static/route/`,
  },
  STATIC_TIMING: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/static/timing/`,
  },
  STATIC_UNITS: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/static/units/`,
  },
  STATIC_MEDICINE_UNITS: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/static/medicine-units/`,
  },
  STATIC_MEDICINE_TIMING: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/static/medicine-timing/`,
  },
  STATIC_VACCINATION_STATUS: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/static/vaccination-status/`,
  },
  STATIC_BRANDS_LIST: {
    baseURL: `${BASE_QC_ORDER}/brands/list/`,
  },
  STATIC_DEWORMING_STATUS: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/static/deworming-status/`,
  },
  STATIC_FOOD_PREFERENCES: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/static/food-preferences/`,
  },
  STATIC_PROGNOSIS: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/static/prognosis/`,
  },
  EMR_IMAGE_UPLOAD: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/record-images/`,
  },
  MEDICINE_PRESCRIPTION_DETAILS: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/medicine-prescriptions/details/`,
  },
  CREATE_MEDICINE_PRESCRIPTION: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/medicine-prescriptions/emr/`,
  },
  FILE_TO_S3_LINK_GENERATOR: {
    baseURL: `${BASE_URL}/clinic-org/vms/file-to-s3-link/`,
  },
  AI_SUMMARY: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/emr/v1/summary/`,
  },
  AI_GENERATE_SUMMARY: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/emr/v1/summary/generate/`,
  },
  VOICE_EMR: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/emr/v1/voice/`,
  },
  VOICE_EMR_WS: {
    baseURL: `${BASE_VETIC_NEEV_URL?.replace(/^http/i, "ws")}/vms/emr/v1/voice/stream`,
  },
  VOICE_EMR_RESULT: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/emr/v1/voice`,
  },
  // Recording state for an EMR — drives the "existing recording found" prompt.
  VOICE_EMR_SESSION: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/emr/v1/voice/session`,
  },
  // EMR generation for a finished recording. Two independent halves called in
  // parallel: `/generate/text` and `/generate/items`.
  VOICE_EMR_GENERATE: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/emr/v1/voice`,
  },
  HEALTH_CERTIFICATE: {
    baseURL: `${BASE_URL}/pet-certificate/vms/preview-vms/`,
  },
  RX_VIEW_URL: {
    baseURL: `${BASE_CART_URL}/rx/view/url/`,
  },
};

export const AUTH_APIS: VeticAuthAPIS = {
  // Prod API Hit
  IAM_LOGIN: {
    baseURL: `${BASE_IAM_URL}/iam/central/login/`,
    params: {},
  },
  TOKEN_REFRESH: {
    baseURL: `${BASE_IAM_URL}/iam/vms/auth/refresh/`,
    params: {},
  },
};

export const PATIENT_WAITING_LIST: VeticPatientWaitingListAPIS = {
  // Prod API Hit
  WAITING_LIST: {
    baseURL: `${BASE_URL}/booking/vms/pwl/`,
    params: {},
  },
  PATIENT_STATS: {
    baseURL: `${BASE_URL}/booking/vms/pwl/stats/`,
    params: {},
  },
  AT_HOME_LISTING: {
    baseURL: `${BASE_URL}/booking/vms/home-services/listing/`,
    params: {},
  },
  AT_HOME_STATUS_ACTION: {
    baseURL: `${BASE_URL}/booking/vms/home-services/details/`,
    params: {},
  },
  AT_HOME_BOOKING_STATUS_SUMMARY: {
    baseURL: `${BASE_URL}/booking/vms/home-services/stats/`,
    params: {},
  },
  AT_HOME_SUB_SERVICES_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/home-services/sub-services/`,
    params: {},
  },
  AT_HOME_BOOKING_STATUSES: {
    baseURL: `${BASE_URL}/booking/vms/home-services/statuses/`,
    params: {},
  },
  AT_HOME_STAFF_LIST: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/pwl/clinic-providers/`,
    params: {},
  },
  GROOMERS_LIST: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/pwl/clinic-providers/groomers/`,
    params: {},
  },
  CLINIC_GROOMERS_LIST: {
    baseURL: `${BASE_URL}/groomer-mapping/clinic-available-groomer/`,
    params: {},
  },
  CITY_GROOMERS_LIST: {
    baseURL: `${BASE_URL}/groomer-mapping/city-groomer-list/`,
    params: {},
  },
  WAITING_LIST_ACTION: {
    baseURL: `${BASE_BOOKING_URL}/v3/vms/bookings/detail/`,
    params: {},
  },
  WAITING_LIST_PET_READT_WHATSAPP: {
    baseURL: `${BASE_BOOKING_URL}/vms/bookings/pet-ready-whatsapp/`,
    params: {},
  },
  TELECONSULTATION_USER_DOCTOR_MEET_DETAILS: {
    baseURL: `${BASE_BOOKING_URL}/teleconsultation/user-doctor-meet-details/`,
    params: {},
  },
};

export const ORG_APIS: VeticOrgAPIS = {
  APP_REQUEST: {
    baseURL: `${BASE_USER_PROFILE_URL}/app-download-whatsapp/`,
    params: {},
  },
  CLINIC_LIST_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/clinic-list/`,
    params: {},
  },
  CITY_LIST: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/pwl/staff-cities/`,
    params: {},
  },
  SERVICES_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/services/`,
    params: {},
  },
  PROVIDERS_LIST: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/pwl/clinic-providers/`,
    params: {},
  },
  SLUG_SEARCH: {
    baseURL: `${BASE_URL}/static-service/api/slug-search/`,
    params: {},
  },
  SLUG_UPDATE: {
    baseURL: `${BASE_URL}/static-service/api/slug-update/`,
    params: {},
  },
  CLICK_LOG_API: {
    baseURL: `${BASE_VETIC_LOG_URL}/retail-app/click-logs/`,
    params: {},
  },
};

export const CLINIC_APIS: VeticClinicAPIS = {
  CLINIC_LIST: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/pwl/staff-clinics/`,
    params: {},
  },
  CLINIC_DETAILS_API: {
    baseURL: `${BASE_URL}/clinic-org/clinic-detail/`,
    params: {},
  },
};

export const MAPPINGS_APIS: VeticMappingAPIS = {
  APPOINTMENT_CART_ITEMS_MAPPING_LIST: {
    baseURL: `${BASE_CART_URL}/appointments-cart-items-mapping/`,
    params: {},
  },
};

// order management api declaration

export const ORDER_APIS: VeticOrdersAPIS = {
  ORDER_STATS: {
    baseURL: `${BASE_QC_URL}/central/sub-order-status-counts/`,
    params: {},
  },
  ORDER_CANCEL_ON_PARTNER: {
    baseURL: `${ORDER_CANCEL_ON_PARTNER_URL}/cancel-order/order/`,
    params: {},
  },
  ORDER_FORCE_STOP_DELIVERY: {
    baseURL: `${BASE_QC_URL}/v1/force-stop-delivery/`,
    params: {},
  },
  EXOTEL_CALL_CONNECT: {
    baseURL: `${EXOTEL_CALL_CONNECT_URL}/lead/exotel/call/connect-two-numbers`,
    params: {},
  },
  ORDER_LIST: {
    baseURL: `${BASE_QC_URL}/central/sub-orders-list/`,
    params: {},
  },
  ORDER_CANCEL_REASON: {
    baseURL: `${BASE_QC_URL}/central/sub-orders-cancel-reasons/`,
    params: {},
  },
  ORDER_CLINIC_LIST: {
    baseURL: `${BASE_URL}/clinic-org/workspace/list`,
    params: {},
  },
  ORDER_ACTION_BUTTON: {
    baseURL: `${BASE_QC_URL}/v1/central/sub-orders-update/`,
    params: {},
  },
  ORDER_ACTION_EXCELATION_BUTTON: {
    baseURL: `${BASE_QC_URL}/central/sub-orders-update/raise-escalation/`,
    params: {},
  },
  ORDER_REATTEMPT_BUTTON: {
    baseURL: `${BASE_QC_URL}/central/reassign/delivery/`,
    params: {},
  },
  ORDER_MANUAL_ASSIGN: {
    baseURL: `${BASE_QC_URL}/central/manual-delivery-statuses/`,
    params: {},
  },
  ORDER_SEARCH_API: {
    baseURL: `${BASE_QC_URL}/central/sub-orders-search/`,
    params: {},
  },
  TRANSFER_ORDER_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/transfer-order/list/`,
    params: {},
  },
  TRANSFER_ORDER_STATS: {
    baseURL: `${BASE_URL}/clinic-org/vms/transfer-order/stats/`,
    params: {},
  },
  CANCEL_TRANSFER_ORDER: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/cancel-transfer-order/`,
    params: {},
  },
  CANCEL_ORDER_PAYMENT_DUE: {
    baseURL: `${BASE_QC_URL}/v1/cancel-hd-order/`,
    params: {},
  },
  TRANSFER_ORDER_OMS_STATS: {
    baseURL: `${BASE_QC_URL}/central/transfer-order-status-counts/`,
    params: {},
  },
  TRANSFER_ORDER_OMS_LIST: {
    baseURL: `${BASE_QC_URL}/central/transfer-orders-list/`,
    params: {},
  },
  VALIDATE_MEDICINE_EXPIRY: {
    baseURL: `${BASE_QC_URL}/central/validate-medicine-expiry/`,
    params: {},
  },
  CENTRAL_ORDER_PAYMENT_LINK: {
    baseURL: `${BASE_QC_URL}/v1/payment_link/`,
    params: {},
  },
  PACKING_ALERTS_COUNT: {
    baseURL: `${BASE_QC_URL}/vms/packing-alerts/count/`,
    params: {},
  },
  PACKING_ALERTS_STREAM: {
    baseURL: `${BASE_QC_URL}/vms/packing-alerts/stream/`,
    params: {},
  },
};

export const CONFIGURATION_APIS: VeticConfigurationAPIS = {
  WAREHOUSE_API: {
    baseURL: `${BASE_URL}/clinic-org/warehouses/`,
  },
  GET_ROLES_AND_PERMISSION_LIST: {
    baseURL: `${BASE_IAM_URL}/iam/vms/role-details/`,
  },
  GET_USER_PERMISSIONS: {
    baseURL: `${BASE_IAM_URL}/iam/vms/staff-role/`,
  },
  CREATE_ROLES_AND_PERMISSION: {
    baseURL: `${BASE_IAM_URL}/iam/vms/roles/`,
  },
  GET_ROLE_DETAILS: {
    baseURL: `${BASE_IAM_URL}/iam/vms/role-details/`,
  },
  LIST_ROLES_AND_PERMISSION: {
    baseURL: `${BASE_IAM_URL}/iam/vms/roles/`,
  },
  UPDATE_ROLES_AND_PERMISSION: {
    baseURL: `${BASE_IAM_URL}/iam/vms/roles/`,
  },

  CITY_DETAILS_BY_PINCODE: {
    baseURL: `${BASE_URL}/clinic-org/pincode/`, // GET
    params: {},
  },
  CITY_LIST: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/city/`, // GET
    params: {},
  },
  SEARCH_MODULE_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/config/search/`,
  },
  CITY_ONBOARD: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/city/`, // POST
    params: {},
  },
  CITY_DETAILS: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/city/update/`, // GET
    params: {},
  },
  CITY_UPDATE: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/city/update/`, // PUT
    params: {},
  },
  STAFF_CATEGORY_ONBOARD: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/staff-categories/`, // POST
    params: {},
  },
  STAFF_CATEGORY_UPDATE: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/staff-categories/update/`, // PUT
    params: {},
  },
  STAFF_CATEGORY_LIST: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/staff-categories/`, // GET
    params: {},
  },
  STAFF_CATEGORY_FILTER: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/staff/`, // GET
    params: {},
  },
  EDIT_STAFF_CATEGORY_DETAILS: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/staff-categories/update/`, // GET
    params: {},
  },
  PROVIDER_CATEGORY_LIST: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/staff-categories/`, // GET
    params: {},
  },
  L1_SERVICE_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/services/`, // GET
    params: {},
  },
  SERVICE_PROVIDERS: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/providers/`, // POST
    params: {},
  },
  SERVICE_CLINIC_PROVIDERS: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/providers/`, // POST
    params: {},
  },
  SERVICE_ONBOARD: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/service/on-boarding/`, // POST
    params: {},
  },
  SERVICE_LIST: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/service/on-boarding/`, // GET
    params: {},
  },
  SERVICE_DETAIL: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/service/on-boarding/detail/`, // GET
    params: {},
  },
  SERVICE_UPDATE: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/service/on-boarding/detail/`, // PUT
    params: {},
  },
  EQUIPMENT_SERVICE_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/services/`, // GET
    params: {},
  },
  EQUIPMENT_LIST: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/equipment/`, // GET
    params: {},
  },
  EQUIPMENT_ONBOARD: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/equipment/`, // POST
    params: {},
  },
  EQUIPMENT_DETAIL: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/equipment/update/`, // GET
    params: {},
  },
  EQUIPMENT_UPDATE: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/equipment/update/`, // PUT
    params: {},
  },
  STAFF_LIST: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/staff/`, // GET
    params: {},
  },
  STAFF_DETAIL: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/staff/update/`, // GET
    params: {},
  },
  STAFF_ROLES: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/staff-roles/`, // GET
    params: {},
  },
  STAFF_CITIES_LIST: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/pwl/staff-cities/`, // GET
    params: {},
  },
  STAFF_CLINICS_BASED_ON_CITY_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/vms/clinics-based-on-cities/`, // GET
    params: { city_ids: "3" },
  },
  STAFF_ONBOARD: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/staff/`, // POST
    params: {},
  },
  STAFF_UPDATE: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/staff/update/`, // PUT
    params: {},
  },
  GROOMER_STAFF_LIST: {
    baseURL: `${BASE_URL}/groomer-mapping/groomer-staff/list/`, // GET
    params: {},
  },
  GROOMER_STAFF_DETAIL: {
    baseURL: `${BASE_URL}/groomer-mapping/groomer-staff/details/`, // GET with id appended
    params: {},
  },
  GROOMER_STAFF_CREATE: {
    baseURL: `${BASE_URL}/groomer-mapping/groomer-staff/create/`, // POST
    params: {},
  },
  CLINIC_GROOMER_MAP_ADD: {
    baseURL: `${BASE_URL}/groomer-mapping/clinic-groomer-mapping/add/`, // POST
    params: {},
  },
  CLINIC_GROOMER_MAP_UPDATE: {
    baseURL: `${BASE_URL}/groomer-mapping/clinic-groomer-mapping/update/`, // POST with clinic id suffix
    params: {},
  },
  PREFERRED_STAFF_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/preferred-staff/`, // GET (?clinic_id), POST create, PUT update
    params: {},
  },
  PARAVET_STAFF_LIST: {
    baseURL: `${BASE_URL}/paravet-mapping/paravet-staff/list/`, // GET
    params: {},
  },
  PARAVET_STAFF_DETAIL: {
    baseURL: `${BASE_URL}/paravet-mapping/paravet-staff/details/`, // GET with id appended
    params: {},
  },
  PARAVET_STAFF_CREATE: {
    baseURL: `${BASE_URL}/paravet-mapping/paravet-staff/create/`, // POST (create + update)
    params: {},
  },
  PARAVET_CLINIC_LIST: {
    baseURL: `${BASE_URL}/paravet-mapping/clinic-paravet-list/`, // GET clinics + their paravets
    params: {},
  },
  CLINIC_PARAVET_MAP_UPDATE: {
    baseURL: `${BASE_URL}/paravet-mapping/clinic-paravet-mapping/update/`, // POST with clinic id suffix
    params: {},
  },
  CITY_PARAVET_LIST: {
    baseURL: `${BASE_URL}/paravet-mapping/city-paravet-list/`, // GET with city id appended
    params: {},
  },
  CLINIC_AVAILABLE_PARAVETS: {
    baseURL: `${BASE_URL}/paravet-mapping/clinic-available-paravets/`, // GET with clinic id appended
    params: {},
  },
  STAFF_PROFILE_SAVE: {
    baseURL: `${BASE_URL}/staff-setup/staff/create/`,
    params: {},
  },
  STAFF_PROFILE_LIST: {
    baseURL: `${BASE_URL}/staff-setup/staff/list/`,
    params: {},
  },
  STAFF_PROFILE_DETAIL: {
    baseURL: `${BASE_URL}/staff-setup/staff/details/`,
    params: {},
  },
  STAFF_CLINIC_LIST: {
    baseURL: `${BASE_URL}/staff-setup/clinic-staff-list/`,
    params: {},
  },
  CITY_STAFF_LIST: {
    baseURL: `${BASE_URL}/staff-setup/city-staff-list/`,
    params: {},
  },
  CLINIC_STAFF_MAP_UPDATE: {
    baseURL: `${BASE_URL}/staff-setup/clinic-staff-mapping/update/`,
    params: {},
  },
  CLINIC_DAILY_ATTENDANCE: {
    baseURL: `${BASE_URL}/attendance/clinic-daily/`,
    params: {},
  },
  ALERT_ACTION_SAVE: {
    baseURL: `${BASE_URL}/attendance/clinic-daily/`,
    params: {},
  },
  CLINIC_CITY_LIST: {
    baseURL: `${BASE_URL}/clinic-org/cities/`, // GET
    params: {},
  },
  CLINIC_LIST_TABLE: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/clinic/`, // GET
    params: {},
  },
  CLINIC_ONBOARD: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/clinic/`, // POST
    params: {},
  },
  CLINIC_OPERATIONAL_CAPACITY: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/operational-capacity/`, // GET
    params: {},
  },
  CLINIC_DETAIL: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/clinic/update/`, // GET
    params: {},
  },
  CLINIC_UPDATE: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/clinic/update/`, // PUT
    params: {},
  },
  CLINIC_COPY_IMAGES: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/copy-images-from-other-clinic/`, // GET
    params: {},
  },
  CLINIC_IMAGES: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/clinic/images/`, // GET, PUT
    params: {},
  },
  ADDRESS_DETAILS_BY_CITY: {
    baseURL: `${BASE_URL}/clinic-org/get-pincode-by-cityname/`, // GET
    params: {},
  },
  SERVICE_SETUP_L1_LIST: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/service/`, // GET Service Setup L1 Service List API
    params: {},
  },
  SERVICE_TYPE_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/service-types/`, // GET Service Types List API
    params: {},
  },
  ADDL1SERVICE: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/service/on-boarding/`, // post Service Setup Add L1 API
    params: {},
  },
};

// Coupon Commerce

export const COUPON_SERVICE_APIS: VeticCouponServiceAPIS = {
  COUPON_LIST: {
    baseURL: `${BASE_QC_COUPON}/vms/coupon`, // POST
    params: {},
  },
  COUPON_CREATION: {
    baseURL: `${BASE_QC_COUPON}/vms/create-coupon`, // POST
    params: {},
  },
  COUPON_UPDATE: {
    baseURL: `${BASE_QC_COUPON}/vms/update-coupon`, // POST
    params: {},
  },
  COUPON_TYPE: {
    baseURL: `${BASE_QC_COUPON}/vms/coupon-type-list`, // POST
    params: {},
  },
  ALLOWCOUPON: {
    baseURL: `${BASE_STATIC_API}/api/static-content/apply_coupon_changes_to/`, // POST
    params: {},
  },
  CART_TYPE: {
    baseURL: `${BASE_STATIC_API}/api/static-content/usage-level/`, // POST
    params: {},
  },
  COUPON_CART_TYPE: {
    baseURL: `${BASE_STATIC_API}/api/static-content/cart-level-discount/`, // POST
    params: {},
  },
  DISCOUNT_TYPE: {
    baseURL: `${BASE_STATIC_API}/api/static-content/discount-type/`, // POST
    params: {},
  },
  UPLOAD_IMAGE_TO_S3: {
    baseURL: `${BASE_QC_ORDER}/s3/upload/`, // GET
    params: {},
  },
  USERPERSONA_LIST_API: {
    baseURL: `${BASE_QC_COUPON}/vms/user-persona`, // GET
    params: {},
  },
  COUPON_SUB_SERVICE_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/sub-service/`, // GET
    params: {},
  },
  COUPON_VMS_CATEGORY: {
    baseURL: `${BASE_URL}/clinic-org/vms/category/`, // GET
    params: {},
  },
  COUPON_VMS_SUB_CATEGORY: {
    baseURL: `${BASE_URL}/clinic-org/vms/subcategory/`, // GET
    params: {},
  },
  COUPON_BOM_LIST: {
    baseURL: `${BASE_URL}/clinic-org/material/billing/`, // GET
    params: {},
  },
  COUPON_PRODUCT_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/product/`, // GET
    params: {},
  },
  REMINDER_API: {
    baseURL: `${BASE_VETIC_NEEV_URL}/reminders/`, // GET
    params: {},
  },
  COMPLETE_REMINDER_API: {
    baseURL: `${BASE_QC_COUPON}/reminders/complete-reminder`, // PUT
    params: {},
  },
  COUPON_SUB_SERVICE_LIST_POST: {
    baseURL: `${BASE_URL}/clinic-org/vms/sub-service/listing/`, // GET
    params: {},
  },
  COUPON_VMS_SUB_CATEGORY_POST: {
    baseURL: `${BASE_URL}/clinic-org/vms/sub-category/listing/`, // GET
    params: {},
  },
  COUPON_BOM_LIST_POST: {
    baseURL: `${BASE_URL}/clinic-org/vms/bom/listing/`, // GET
    params: {},
  },
  COUPON_PRODUCT_LIST_POST: {
    baseURL: `${BASE_URL}/clinic-org/vms/product/listing/`, // GET
    params: {},
  },
  COUPON_LISTING_NEW: {
    baseURL: `${BASE_QC_COUPON}/vms/coupon-listing`, // POST
    params: {},
  },
  PINCODE_LISTING: {
    baseURL: `${BASE_URL}/clinic-org/pincode-listing`, // GET
    params: {},
  },
  UPLOAD_VARIANTS: {
    baseURL: `${BASE_QC_COUPON}/vms/validate-variant-ids`, // POST
    params: {},
  },
  USER_LEVEL_COUPON: {
    baseURL: `${BASE_QC_COUPON}/vms/user-level-coupon`, // POST create, GET list
    params: {},
  },
  USER_LEVEL_COUPON_REASONS: {
    baseURL: `${BASE_QC_COUPON}/vms/user-level-coupon/reasons`, // GET reason list
    params: {},
  },
};

// Quick Commerce

export const QUICK_COMMERCE_APIS: VeticQuickCommerceAPIS = {
  PINCODE_ONBOARD: {
    baseURL: `${BASE_URL}/clinic-org/vms/pincode/`, // POST
    params: {},
  },
  PINCODE_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/pincode/`, // GET
    params: {},
  },
  PINCODE_DETAIL: {
    baseURL: `${BASE_URL}/clinic-org/vms/pincode-details/`, // GET
    params: {},
  },
  PINCODE_UPDATE: {
    baseURL: `${BASE_URL}/clinic-org/vms/pincode-details/`, // PUT
    params: {},
  },
};

/**
 * Pincode weather (rain) settings — served by the `weather` app in clinic_org,
 * operating on the quick_commerce `pincodes` Mongo collection.
 */
export const PINCODE_WEATHER_APIS = {
  // GET list (optional ?city=&is_raining=&search=) ; GET/PUT single by appending `${pincode}/`
  PINCODE_WEATHER: `${BASE_URL}/clinic-org/weather/pincodes/`,
  // PATCH bulk update
  PINCODE_WEATHER_BULK: `${BASE_URL}/clinic-org/weather/pincodes/bulk/`,
  WEATHER_REASONS: `${BASE_URL}/clinic-org/weather/weather/reasons/`,
};

export const HOME_TILE_CONFIG_APIS = {
  TILES: `${BASE_URL}/home-tiles/`,
  CONFIGS: `${BASE_URL}/home-tiles/config/`,
};

export const SURGE_PRICING_APIS = {
  RULES: `${BASE_QC_COUPON}/vms/surge-pricing/rules`,
  PERSONAS: `${BASE_QC_COUPON}/vms/surge-pricing/personas`,
  PREVIEW: `${BASE_QC_COUPON}/vms/surge-pricing/preview`,
  PRICE_CHECK: `${BASE_QC_COUPON}/vms/surge-pricing/price-check`,
};

export const CLINIC_TAG_CONFIG_APIS = {
  CONFIGS: `${BASE_URL}/clinic-org/v3/vms/clinic/persona-config/`,
};

export const GIFT_CONFIG_APIS = {
  ACTIONS: `${BASE_CART_URL}/gifts/actions/`, // POST { action: list | fetch | insert | update | delete }
};

export const STORE_TIMING_APIS = {
  LIST: `${BASE_URL}/qc/qc-timing-setup/list/`,
  UPDATE_BY_WAREHOUSE: `${BASE_URL}/qc/qc-timing-setup/update/`,
};

// Slots

export const SLOTS_APIS: VeticSlotsAPIS = {
  LATEST_BOOKING: {
    baseURL: `${BASE_BOOKING_URL}/latest/`,
    params: {},
  },
  PURCHASE_OPTIONS: {
    baseURL: `${BASE_BOOKING_URL}/purchase-options/`,
    params: {},
  },
  SERVICE_PRICING: {
    baseURL: `${BASE_BOOKING_URL}/service-pricing/`,
    params: {},
  },
  CART_PREVIEW: {
    baseURL: `${BASE_BOOKING_URL}/preview/`,
    params: {},
  },
  SEND_PAYMENT_LINK: {
    baseURL: `${BASE_BOOKING_URL}/vms/payment-link-whatsapp/`,
  },
  IS_RESCHEDULE_PAID_ORNOT: {
    baseURL: `${BASE_BOOKING_URL}/reschedule/payment/status/`,
  },
  IS_CANCEL_PAID_ORNOT: {
    baseURL: `${BASE_BOOKING_URL}/cancel/payment/status/`,
  },
  LATE_BOOKING_CHECK: {
    baseURL: `${BASE_BOOKING_URL}/vms/slot-status`,
  },
  BOOKED_SLOTS_DETAILS: {
    baseURL: `${BASE_URL}/clinic-org/vms/booked-slots/detail/`,
  },
  BOOKED_SLOTS_LIST: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/available-slots/`,
    params: {},
  },
  AT_HOME_BOOKED_SLOTS_LIST: {
    baseURL: `${BASE_URL}/slots/vms/booked/`,
    params: {},
  },
  NEAREST_CLINIC_FETCH: {
    baseURL: `${BASE_URL}/clinic-org/vms/nearest-clinics/`,
    params: {},
  },
  SINGLE_BOOKING_DETAILS: {
    baseURL: `${BASE_BOOKING_URL}/v3/vms/bookings/detail/`,
    params: {},
  },
  SLOTS_LIST: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/available-slots/`,
    params: {},
  },
  AT_HOME_SLOTS_LIST: {
    baseURL: `${BASE_URL}/slots/vms/available/`,
    params: {},
  },
  BOOKING_CREATION: {
    baseURL: `${BASE_BOOKING_URL}/v3/vms/bookings/`,
    params: {},
  },
  BOOKING_SUMMARY: {
    baseURL: `${BASE_BOOKING_URL}/summary/`,
    params: {},
  },
  AT_HOME_BOOKING_CREATION: {
    baseURL: `${BASE_URL}/booking/vms/`,
    params: {},
  },
  AT_HOME_REASONS_LIST: {
    baseURL: `${BASE_URL}/booking/home-services/reasons/`,
    params: {},
  },
  AT_HOME_AVAILABLE_DOCTORS: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/available-doctors/`,
    params: {},
  },
  BOOKING_RECSHEDULE: {
    baseURL: `${BASE_BOOKING_URL}/v3/vms/bookings/detail`,
    params: {},
  },
  MEMBERSHIP_LIST: {
    baseURL: `${BASE_MEMBERSHIP_URL}/api/membership/v2/packages/?is_member=false&latitude=28.4042326&longitude=77.0588898`,
    params: {},
  },
  MEMBERSHIP_OPTIONS: {
    baseURL: `${BASE_BOOKING_URL}/membership-options/`,
    params: {},
  },

  SURGERY_OPTIONS: {
    baseURL: `${BASE_BOOKING_URL}/surgery-options/`,
    params: {},
  },

  COUPONS_LIST: {
    baseURL: `${BASE_URL}/booking/vms/discount-coupons/`,
    params: {},
  },
  ALTERNATIVE_COUPONS_LIST: {
    baseURL: `${BASE_BOOKING_URL}/v3/vms/alternative-service-discount-coupons/`,
    params: {},
  },
  //overbooking api
  CREATE_OVER_BOOKING: {
    baseURL: `${BASE_URL}/clinic-org/vms/over-booking/`,
    params: {},
  },
  CART_EXCEPTIONS: {
    baseURL: `${BASE_URL}/booking/exemptions/eligible-bookings/`,
    params: {},
  },
  CART_EXEMPTION_DELETE: {
    baseURL: `${BASE_VETIC_NEEV_URL}/exemptions/`,
    params: {},
  },
  BDE_USER_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/over-booking/vms-users/`,
    params: {},
  },
  //overbooking list
  OVER_BOOKING_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/over-booking/`,
    params: {},
  },
  //front desk overbooking: providers with ROTA for clinic x sub service x date
  FRONT_DESK_DOCTOR_ROTA: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/pwl/frontdesk/ob-list/`, // POST
    params: {},
  },
  OVERBOOKING_BOOKING_ALLOWED: {
    baseURL: `${BASE_URL}/clinic-org/vms/check-slots/`,
  },
  OVER_BOOKING_PERMISION_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/over-booking/over-booking-for-super-users/`,
    params: {},
  },
  //haircut as bath
  HAIR_CUT_GROOMERS_LIST: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/hairdresserstaff/details`,
    params: {},
  },
  //haircut as bath post API
  HAIR_CUT_TO_BATH: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/allow-hairdresser-to-other-service/`,
    params: {},
  },
  HAIR_CUT_TO_BATH_SERVICES: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/allow-hairdresser-to-other-service/allowed-services/`,
    params: {},
  },
  SHIFT_APPOINTMENT: {
    baseURL: `${BASE_URL}/booking/vms/shifted-bookings/`,
    params: {},
  },
  SHIFT_APPOINTMENT_COUNT: {
    baseURL: `${BASE_URL}/booking/vms/shifted-bookings-count/`,
    params: {},
  },
  BOOKING_EXEMPTION_REASON: {
    baseURL: `${BASE_VETIC_NEEV_URL}/exemptions/`,
    params: {},
  },
};

//Rota Management
export const ROTA_APIS: VeticRotaAPIS = {
  ROTA_SHIFT_STATS_LIST: {
    baseURL: `${BASE_URL}/rota-management/shift-stats/`,
    params: {},
  },
  ROTA_SHIFT_LIST: {
    baseURL: `${BASE_URL}/rota-management/shift/`,
    params: {},
  },
  ROTA_SHIFT_CREATE: {
    baseURL: `${BASE_URL}/rota-management/shift/`,
    params: {},
  },
  ROTA_SHIFT_DETAILS: {
    baseURL: `${BASE_URL}/rota-management/shift/`,
    params: {},
  },
  ROTA_SHIFT_UPDATE: {
    baseURL: `${BASE_URL}/rota-management/shift/`,
    params: {},
  },
  ROTA_SHIFT_CATEGORY: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/staff-categories/`,
    params: {},
  },
  ROTA_SHIFT_PROVIDER: {
    baseURL: `${BASE_URL}/clinic-org/v3/vms/providers/`,
    params: {},
  },
  ROTA_SHIFT_FILTER: {
    baseURL: `${BASE_URL}/rota-management/clinic-wise-staffs/`,
    params: {},
  },
  ROTA_CREATE_API: {
    baseURL: `${BASE_URL}/rota-management/rota/`,
    params: {},
  },
  ROTA_UPDATE_API: {
    baseURL: `${BASE_URL}/rota-management/rota/`,
    params: {},
  },
  ROTA_SHIFT_DETAILS_API: {
    baseURL: `${BASE_URL}/rota-management/rota-filtered/`,
    params: {},
  },
  ROTA_UPDATION_WARN_API: {
    baseURL: `${BASE_URL}/rota-management/rota-deletion-warn/`,
    params: {},
  },
  ROTA_DELETE_API: {
    baseURL: `${BASE_URL}/rota-management/rota/`,
    params: {},
  },
  ROTA_SHIFT_NAME_API: {
    baseURL: `${BASE_URL}/rota-management/shift-for-rota/`,
    params: {},
  },
  ROTA_SHIFT_COPY_API: {
    baseURL: `${BASE_URL}/rota-management/copy-rota/`,
    params: {},
  },
  ROTA_ERROR_LIST_API: {
    baseURL: `${BASE_URL}/rota-management/errors/`,
    params: {},
  },
  ROTA_OVERBOOKING_ELIGIBLE_SERVICES: {
    baseURL: `${BASE_URL}/rota-management/overbooking-requests/eligible-services/`,
    params: {},
  },
  ROTA_OVERBOOKING_REQUESTS: {
    baseURL: `${BASE_URL}/rota-management/overbooking-requests/`,
    params: {},
  },
  ROTA_OVERBOOKING_BULK_UPLOAD: {
    baseURL: `${BASE_URL}/rota-management/overbooking-requests/bulk-upload/`,
    params: {},
  },
  ROTA_SLOT_REMOVALS: {
    baseURL: `${BASE_URL}/rota-management/slot-removals/`,
    params: {},
  },
  ROTA_SLOT_REMOVALS_STAFF: {
    baseURL: `${BASE_URL}/rota-management/slot-removals/staff/`,
    params: {},
  },
  ROTA_SLOT_REMOVALS_CLINIC_STAFF: {
    baseURL: `${BASE_URL}/rota-management/slot-removals/clinic-staff/`,
    params: {},
  },
  ROTA_SLOT_REMOVALS_BULK_UPLOAD: {
    baseURL: `${BASE_URL}/rota-management/slot-removals/bulk-upload/`,
    params: {},
  },
  ROTA_BOOKING_FEE_CONFIG: {
    baseURL: `${BASE_URL}/booking/vms/booking-fee-configuration/save/`,
    params: {},
  },
  ROTA_BOOKING_FEE_CONFIG_LIST: {
    baseURL: `${BASE_URL}/booking/vms/booking-fee-configuration/list/`,
    params: {},
  },
  ROTA_BOOKING_FEE_CONFIG_DEACTIVATE: {
    baseURL: `${BASE_URL}/booking/vms/booking-fee-configuration/deactivate/`,
    params: {},
  },
};

//Invoce
export const INVOICE_APIS: VeticInvoiceAPIS = {
  INVOICE_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/invoices/`,
    params: {
      // page_num=1&limit=10&user_id=456541f8-7e55-444f-99ca-84018fc7ec33
    },
  },
  DAILY_REVENUE_PAYMENTS: {
    baseURL: `${BASE_URL}/clinic-org/vms/invoices/daily-revenue-payments/`,
    params: {},
  },
};

//Pet Insurance
export const PET_INSURANCE_APIS: VeticPetInsuranceAPIS = {
  FORMS_LIST: {
    baseURL: `${BASE_VETIC_NEEV_URL}/app/v1/pet-insurance/forms`,
    params: {},
  },
  SEND_FORM_URL: {
    baseURL: `${BASE_VETIC_NEEV_URL}/app/v1/pet-insurance/forms/send-form-url`,
    params: {},
  },
};

//Staff Calendar

export const STAFF_CALENDAR: VeticStaffCalendarAPIS = {
  STAFF_FILTER_API: {
    baseURL: `${BASE_URL}/booking/vms/bookings/calender-view/`,
    params: {},
  },
  STAFF_BOOKING_DETAILSAPI: {
    baseURL: `${BASE_URL}/booking/vms/bookings/calender-view/detail/`,
    params: {},
  },
};

// Inventory
export const INVENTORY_MODULE: VeticInventoryModuleAPIS = {
  VENDOR_DETAILS: {
    baseURL: `${BASE_URL}/clinic-org/vms/vendor/detail/`,
  },
  VENDOR_ADD: {
    baseURL: `${BASE_URL}/clinic-org/vms/vendor/`,
  },
  VENDOR_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/vendor/`,
  },
  //Batching
  BATCH_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/batch-group/`,
    params: {},
  },
  BATCH_CREATE: {
    baseURL: `${BASE_URL}/clinic-org/vms/batch-group/`,
    params: {},
  },
  //Manufacturere
  MANUFACTURER_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/manufacturer/`,
    params: {},
  },
  MANUFACTURER_LIST_ACTIVE: {
    baseURL: `${BASE_URL}/clinic-org/vms/manufacture/active-list/`,
    params: {},
  },
  MANUFACTURER_DETAILS: {
    baseURL: `${BASE_URL}/clinic-org/vms/manufacturer/detail/`,
    params: {},
  },
  COUNTRY_LIST: {
    baseURL: `${BASE_URL}/clinic-org/countries/`,
    params: {},
  },
  //Tax
  TAX_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/tax/`,
    params: {},
  },
  ACTIVE_TAX_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/tax/product/`,
    params: {},
  },
  TAX_DETAILS: {
    baseURL: `${BASE_URL}/clinic-org/vms/tax-details/`,
    params: {},
  },
  //Product
  PRODUCT_VETIC_CATEGORY: {
    baseURL: `${BASE_URL}/clinic-org/vms/mbrt/product/categories/`,
    params: {},
  },
  PRODUCT_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/product/`,
    params: {},
  },
  PRODUCT_VMS_CATEGORIES: {
    baseURL: `${BASE_URL}/clinic-org/vms/product/`,
    params: {},
  },
  PRODUCT_CREATE_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/product/`,
    params: {},
  },
  PRODUCT_UPDATE_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/product-details/`,
    params: {},
  },
  VARIANT_PERSONA_DISCOUNTS_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/variant-persona-discounts/`,
    params: {},
  },
  //Catalog
  PRODUCT_CATALOGUE_DROPDOWN: {
    baseURL: `${BASE_URL}/clinic-org/vms/product-catalogue-dropdown/`,
    params: {},
  },
  PRODUCT_CATALOGUE_DROPDOWN_CREATE: {
    baseURL: `${BASE_URL}/clinic-org/vms/create-product-catalogue-dropdown/`,
    params: {},
  },
  PRODUCT_CATEGORY_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/product/`,
    params: {},
  },
  PRODUCT_UNITCOUNT: {
    baseURL: `${BASE_URL}/clinic-org/vms/product-catalogue-dropdown/UNITCOUNT/`,
    params: {},
  },
  PRODUCT_STATUS_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/product/status/`,
    params: {},
  },
  PACK_SELL_ELIGILIBILITY: {
    baseURL: `${BASE_URL}/clinic-org/vms/pack-sell-eligibility/`,
    params: {},
  },
  PRODUCT_SUB_DETAILS: {
    baseURL: `${BASE_URL}/clinic-org/vms/product-subdetails/`,
    params: {},
  },

  //purchase status list
  PURCHASE_STATUS_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/po-statuses/`,
    params: {},
  },
  PURCHASE_ORDER_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/purchase/orders-list/`,
    params: {},
  },
  PURCHASE_ORDER_PO_ID_CREATE: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/purchase-order/`,
    params: {},
  },
  PURCHASE_ORDER_UPDATE: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/purchase-order-update/`,
    params: {},
  },
  PURCHASE_ORDER_DETAILS: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/purchase-order/details/`,
    params: {},
  },
  PURCHASE_ORDER_VENDOR_BRANCH: {
    baseURL: `${BASE_URL}/clinic-org/vms/vendor/branches/`,
    params: {},
  },
  PURCHASE_ORDER_PRODUCT_SEARCH: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/purchase-order/product/search/`,
    params: {},
  },
  PURCHASE_ORDER_INFORMATION_CALCULATION: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/purchase-order/calculate-product-information/`,
    params: {},
  },
  PURCHASE_ORDER_VENDOR_SEARCH: {
    baseURL: `${BASE_URL}/clinic-org/vms/vendor/search/`,
  },
  PURCHASE_ORDER_VIEW: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/purchase-order-line-item-view`,
  },
  // GRN
  GRN_SHORT_RECEIVE_REASON: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/goods-received-note/short-receive-reasons/`,
    params: {},
  },
  GRN_DETAIL_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/goods-received-note/detail/`,
    params: {},
  },
  GRN_UPDATE_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/goods-received-note/detail/`,
    params: {},
  },
  GRN_SUB_GRN_LIST_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/sub-goods-received-note/detail/`,
  },
  GRN_SUB_GRN_DELETE_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/sub-goods-received-note/remove-item/`,
  },
  STOCK_ITEMS_SEARCH_API: {
    baseURL: `${BASE_URL}/clinic-org/stock-items/search/?search=`,
    params: {},
  },
  STOCK_ITEMS_POST_API: {
    baseURL: `${BASE_URL}/clinic-org/stock-incomplete/`,
    params: {},
  },
  UNIT_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/weight-units/`,
    params: {},
  },
  DISCOUNT_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/discount-type/`,
    params: {},
  },
  PURCHASE_ORDER_PDF: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/purchase-order/generate-pdf/`,
  },
  PURCHASE_ORDER_BULK_UPLOAD: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/purchase-order/bulk-upload/`,
  },
  PURCHASE_ORDER_CREATE_FROM_SHEET: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/purchase-order/create-from-sheet/`,
  },
  PURCHASE_ORDER_SHEET_TABS: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/purchase-order/sheet-tabs/`,
  },
  PURCHASE_ORDER_BULK_CLEAR: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/purchase-order/clear/`,
  },
  PRODUCT_SEARCH_BY_CLINIC_ID: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/purchase-order/clinic-wise/product/search/`,
  },
  REASON_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/good-to-bad/reasons/`,
  },
  PRODUCT_FILTER: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/filtered-data-list/`,
  },
  MOVE_GOOD_TO_BAD: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/movement/good-to-bad/`,
    params: {},
  },
  STATUS_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/bad-inventory/statuses/`,
  },
  BAD_INVENTORY_DATA: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/bad-inventory-data/`,
    params: {},
  },
  BAD_INVENTORY_ACTIONS: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/actions-on-bad-inventory/`,
    params: {},
  },
  ORDER_TRANSFER_STATUS_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/inventory-transfer-statues/`,
    params: {},
  },
  CLINIC_TO_DOCTOR_TRANSFER_DOCTORS: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/v1/inventory-transfer/doctors/list`,
    params: {},
  },
  CLINIC_TO_DOCTOR_TRANSFER_STATUSES: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/v1/inventory-transfer/statuses`,
    params: {},
  },
  CLINIC_TO_DOCTOR_REQUEST: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/v1/inventory-transfer/requests`,
    params: {},
  },
  CLINIC_TO_DOCTOR_REQUEST_LIST: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/v1/inventory-transfer/requests/list`,
    params: {},
  },
  DOCTOR_INVENTORY_LIST: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/v1/inventory-transfer/doctor-inventory/list`,
    params: {},
  },
  ORDER_TRANSFER_BRANDS_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/brands/`,
    params: {},
  },
  ORDER_TRANSFER_INVENTORY_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/inventory-transfer-list/`,
    params: {},
  },
  DEFAULT_TRANSFER_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/variant-recommendations/`,
    params: {},
  },
  ORDER_TRANSFER_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/list-of-transfer-orders/`,
    params: {},
  },
  TO_NUMBER: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/get-transfer-order-number/`,
    params: {},
  },
  TRANSFER_ORDER_SEARCH: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/transfer-order-products/search/`,
    params: {},
  },
  GRN_AGAINST_TRANSFER_ORDER: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/grn-against-transfer-order/`,
    params: {},
  },
  CREATE_TRANSFER_ORDER: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/create-transfer-order/`,
    params: {},
  },
  TRANSFER_ORDER_DETAILS: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/transfer-order/details/`,
    params: {},
  },
  PARENT_THEME_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/product/parent-theme/`,
    params: {},
  },
  PARENT_TITLE_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/product/list/`,
    params: {},
  },
  PRODUCT_COPY_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/product/copy-details/`,
    params: {},
  },
  CLINIC_TAMS_FILTER_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/clinic-tams-filters/`, // GET
    params: {},
  },
  BOM_SETUP_LIST_API: {
    baseURL: `${BASE_URL}/clinic-org/material/billing/`,
    params: {},
  },
  BOM_SETUP_ONBOARD_API: {
    baseURL: `${BASE_URL}/clinic-org/material/billing/`,
    params: {},
  },
  BOM_SETUP_DETAIL_API: {
    baseURL: `${BASE_URL}/clinic-org/material/billing/details/`,
    params: {},
  },
  BOM_SETUP_UPDATE_API: {
    baseURL: `${BASE_URL}/clinic-org/material/billing/details/`,
    params: {},
  },
  BOM_SETUP_CITY_LIST_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/cities/details/`,
    params: { city_id: "" },
  },
  CLINIC_WAREHOUSE_DETAILS_BY_CATEGORY_ID: {
    baseURL: `${BASE_URL}/clinic-org/vms/mbrt/clinic-warehouse-details/`,
    params: {},
  },
  SHRINK_REASONS_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/shrink-reasons/`,
    params: {},
  },
  SHRINK_UPDATE: {
    baseURL: `${BASE_URL}/clinic-org/shrink/good-inventory/`,
    params: {},
  },
  GROUP_ITEMS_ACTION_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/items-based-on-type/`,
    params: {},
  },
  GROUP_ITEMS_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/item-group/`,
    params: {},
  },
  GROUP_ITEMS_ONBOARD: {
    baseURL: `${BASE_URL}/clinic-org/vms/item-group/`,
    params: {},
  },
  GROUP_ITEMS_DETAIL: {
    baseURL: `${BASE_URL}/clinic-org/vms/item-group/details/`,
    params: {},
  },
  GROUP_ITEMS_UPDATE: {
    baseURL: `${BASE_URL}/clinic-org/vms/item-group/details/`,
    params: {},
  },
  CATEGORY_DETAIL: {
    baseURL: `${BASE_URL}/clinic-org/vms/category/details/`, // GET
    params: {},
  },
  CATEGORY_UPDATE: {
    baseURL: `${BASE_URL}/clinic-org/vms/category/details/`, // PUT
    params: {},
  },
  EMR_SECTION: {
    baseURL: `${BASE_URL}/clinic-org/vms/subcategory/emr-search/`, // GET
    params: {},
  },
  SUB_CATEGORY_LIST: {
    baseURL: `${BASE_URL}/clinic-org/v1/vms/subcategory/`, // GET
    params: {},
  },
  SUB_CATEGORY_ONBOARD: {
    baseURL: `${BASE_URL}/clinic-org/vms/category-subcategory/setup/`, // POST
    params: {},
  },
  SUB_CATEGORY_DETAIL: {
    baseURL: `${BASE_URL}/clinic-org/vms/category-subcategory/setup/`, // GET
    params: {},
  },
  SUB_CATEGORY_UPDATE: {
    baseURL: `${BASE_URL}/clinic-org/vms/category-subcategory/setup/`, // PUT
    params: {},
  },
  CATEGORY_MAPPING_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/category-subcategory-mapping/`, // GET
    params: {},
  },
  CATEGORY_MAPPING_ONBOARD: {
    baseURL: `${BASE_URL}/clinic-org/vms/category-subcategory-mapping/`, // POST
    params: {},
  },
  CATEGORY_MAPPING_DETAIL: {
    baseURL: `${BASE_URL}/clinic-org/vms/category-subcategory-mapping/edit-details/`, // GET
    params: {},
  },
  CATEGORY_MAPPING_UPDATE: {
    baseURL: `${BASE_URL}/clinic-org/vms/category-subcategory-mapping/`, // PUT
    params: {},
  },
  GET_PRODUCT_COST: {
    baseURL: `${BASE_URL}/clinic-org/vms/grn/get-product-cost/`, // GET
    params: {},
  },
  ADD_INVENTORY_REASON: {
    baseURL: `${BASE_URL}/clinic-org/vms/grn/get-direct-grn-reasons/`, // GET
    params: {},
  },
  ADD_INVENTORY_ONBOARD: {
    baseURL: `${BASE_URL}/clinic-org/vms/grn/instant/`, // POST
    params: {},
  },
  MRP_UPDATE_SEARCH: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/search/lot-wise-stock/`, // POST
    params: {},
  },
  MRP_UPDATE: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/update-price/`, // POST
    params: {},
  },
  PO_DELETE: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/purchase-order/`, // DELETE
    params: {},
  },
  AUDIT_TRAIL_ACTION: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/v1/inventory/audit-trail-actions/`, // GET
    params: {},
  },
  AUDIT_TRAIL_TABLE_DATA_SUMMARY: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/v1/inventory/clinic-sku-history/`, // POST
    params: {},
  },
  AUDIT_TRAIL_EXPORT_CSV: {
    baseURL: `${BASE_VETIC_NEEV_URL}/vms/v1/inventory/audit-trail-export/`, // POST
    params: {},
  },
  AUDIT_TRAIL_EXPORT_CSV_CLINIC_TAMS: {
    baseURL: `${BASE_URL}/clinic-org/vms/clinics-tams-by-cities/`, // POST
    params: {},
  },
  AWAITING_GRN_PO_DELETE: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/purchase-order/remove-grn-item/`, // POST
    params: {},
  },
  EXTRACT_INVOICE_DETAILS: {
    baseURL: `${BASE_URL}/clinic-org/vms/ocr/extract-invoice-details/`, // POST
    params: {},
  },
  FINANCE_PURCHASE_ORDER_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/finance/purchase-orders-list/`, // POST
    params: {},
  },
  FINANCE_ACTIONS: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/purchase-order/finance-actions/`, // POST
    params: {},
  },
  FINANCE_CONFIG_CHANGE_ACTION: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/finance/config-change/`, // PUT //POST
    params: {},
  },
  PO_ACTIONS: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/purchase-order/actions/`, // POST
    params: {},
  },
  BOM_VIAL_TYPE: {
    baseURL: `${BASE_URL}/clinic-org/material/vial-type/`, // GET
    params: {},
  },
  BOM_VACCINE_FAMILY_DOSE: {
    baseURL: `${BASE_URL}/clinic-org/material/vaccine-family-and-dose/`, // GET
    params: {},
  },
  BOM_TAX_ONBOARD: {
    baseURL: `${BASE_URL}/clinic-org/material/billing/tax-details`, // PUT
    params: {},
  },
  BOM_SAMPLE_TYPE: {
    baseURL: `${BASE_URL}/clinic-org/material/sample-type/`, // GET
  },
  BOM_LIS_PARAMETERS: {
    baseURL: `${BASE_URL}/lab-management/lis/v1/parameters/active`, // GET
  },
  SERVICE_BILLABLE: {
    baseURL: `${BASE_URL}/clinic-org/billable-sub-services/`, // GET
    params: {},
  },
  MEDICINE_CONSUMPTION_UNIT: {
    baseURL: `${BASE_URL}/clinic-org/vms/emr/static/medicine-units/`, // GET
    params: {},
  },
  BULK_UPDATE_DISCOUNT: {
    baseURL: `${BASE_QC_ORDER}/bulk/update-discount/upload`,
    params: {},
  },
  BULK_UPDATE_BUSINESS_SCORE: {
    baseURL: `${BASE_QC_ORDER}/bulk/update-business-score/upload`,
    params: {},
  },
  CATALOG_DUMP_DETAILS: {
    baseURL: `${BASE_QC_ORDER}/dump/details`,
    params: {},
  },
  BULK_UPDATE_PERSONA_DISCOUNT: {
    baseURL: `${BASE_URL}/clinic-org/vms/variant-persona-discounts/bulk-upload/`,
    params: {},
  },
  PRODUCT_REQUIREMENT_FORM_CREATE: {
    baseURL: `${BASE_URL}/clinic-org/vms/inventory/product-requirement-form/`,
    params: {},
  },
};

//CBL
export const CBL_APIS: VeticCBLAPIS = {
  CBL_STATS_API: {
    baseURL: `${BASE_BOOKING_URL}/paid/booking/stats/`,
    params: {},
  },
  CBL_FILTER_API: {
    baseURL: `${BASE_BOOKING_URL}/paid/booking/details/`,
    params: {},
  },
  CBL_FILTER_CARD_API: {
    baseURL: `${BASE_BOOKING_URL}/vms/paid-booking-stats/details/`,
  },
};
//Service Desk

export const SERVICE_DESSK_APIS: VeticServiceDeskAPI = {
  SERVICE_DESK_L1_LIST: {
    baseURL: `${BASE_QC_URL}/vms/escalation-static-data/?source=VMS`,
    params: {},
  },
  SERVICE_DESK_CREATE: {
    baseURL: `${BASE_QC_URL}/central/escalation-ticket/`,
    params: {},
  },
  SERVICE_DESK_TICKET_LIST: {
    baseURL: `${BASE_QC_URL}/central/escalation-ticket-list/`,
    params: {},
  },
};

export const CART_MODULE: VeticCartModuleAPIS = {
  CM_BOOKING_INVITE: {
    baseURL: `${BASE_CART_URL}/vms/cart/checkout/cm-booking-invite`,
    params: {},
  },
  CM_BOOKING_TEMPLATE: {
    baseURL: `${BASE_CART_URL}/vms/cart/checkout/cm-booking-template`,
    params: {},
  },
  CM_BOOKING_INVITE_REASONS: {
    baseURL: `${BASE_CART_URL}/vms/cart/checkout/send-invite-reason`,
    params: {},
  },
  CM_BOOKING_MIRROR: {
    baseURL: `${BASE_CART_URL}/vms/cart/checkout/cm-booking-mirror`,
    params: {},
  },
  MIRROR_STATE: {
    baseURL: `${BASE_CART_URL}/vms/cart/mirror-state`,
    params: {},
  },
  EMR_LIST: {
    baseURL: `${BASE_CART_URL}/vms/cart/mirror-emr-items`,
    params: {},
  },
  CART_LEVEL_COUPON: {
    baseURL: `${BASE_CART_URL}/vms/cart/cart-level-coupons`,
    params: {},
  },
  CART_DETAILS_API_FOR_MIRROR: {
    baseURL: `${BASE_CART_URL}/vms/cart/mirror-items`,
    params: {},
  },
  CART_STATUS: {
    baseURL: `${BASE_CART_URL}/vms/cart/status`,
    params: {},
  },
  CART_ITEM_DELETE: {
    baseURL: `${BASE_CART_URL}/vms/cart/delete-cart-items`,
  },
  CART_DETAILS: {
    baseURL: `${BASE_CART_URL}/vms/cart/cart-items`,
  },
  NEW_CART: {
    baseURL: `${BASE_CART_URL}/vms/cart/get-cart-id`,
  },
  CART_LIST: {
    baseURL: `${BASE_CART_URL}/vms/cart/list`,
    params: {},
  },
  CART_CALLOUTS: {
    baseURL: `${BASE_URL}/clinic-org/vms/cart-callouts/`,
    params: {},
  },
  CART_APPOINTMENT_COMMENTS: {
    baseURL: `${BASE_CART_URL}/vms/cart/appointment/comment`,
    params: {},
  },
  CART_SEARCH: {
    baseURL: `${BASE_CART_URL}/vms/cart/cart-item-search`,
    params: {},
  },
  CART_SEARCH_ITEM_CLICK: {
    baseURL: `${BASE_CART_URL}/vms/cart/item-search-click`,
    params: {},
  },
  CART_CHECKOUT: {
    baseURL: `${BASE_CART_URL}/vms/cart/checkout/invoice-payments`,
    params: {},
  },
  SNAPMINT_EMI_API: {
    baseURL: `${BASE_PAYMENT_URL}/v1/vms/payments/collect-snapmint-payment/`,
    params: {},
  },
  SNAPMINT_CANCEL_API: {
    baseURL: `${BASE_PAYMENT_URL}/v1/vms/payments/cancel-emi-order/`,
    params: {},
  },
  SNAPMINT_EMI_STATUS: {
    baseURL: `${BASE_PAYMENT_URL}/v1/vms/payments/check-snapmint-payment-status/`,
    params: {},
  },

  USER_LEVEL_INVOICE: {
    baseURL: `${BASE_CART_URL}/vms/cart/billing/invoices`,
    params: {},
  },
  INVOICE_STATUS_API: {
    baseURL: `${BASE_CART_URL}/vms/cart/get-all-invoice-statuses`,
    params: {},
  },
  DELETE_CART_API: {
    baseURL: `${BASE_CART_URL}/vms/cart/delete-cart`,
    params: {},
  },
  INVOICE_CANCELLATION_REASON: {
    baseURL: `${BASE_CART_URL}/vms/cart/billing/invoice-cancellation-reasons/`,
    params: {},
  },
  INVOICE_CANCEL: {
    baseURL: `${BASE_CART_URL}/vms/cart/billing/invoice-cancel/`,
    params: {},
  },
  INVOICE_RETURN_REFUND: {
    baseURL: `${BASE_CART_URL}/vms/cart/billing/invoice-return-refund/`,
    params: {},
  },
  URGENT_CANCEL_START: {
    baseURL: `${BASE_CART_URL}/vms/cart/billing/urgent-cancel/start`,
    params: {},
  },
  URGENT_CANCEL_CART: {
    baseURL: `${BASE_CART_URL}/vms/cart/billing/urgent-cancel/cart`,
    params: {},
  },
  URGENT_CANCEL_EDIT: {
    baseURL: `${BASE_CART_URL}/vms/cart/billing/urgent-cancel/edit`,
    params: {},
  },
  URGENT_CANCEL_CHECKOUT: {
    baseURL: `${BASE_CART_URL}/vms/cart/billing/urgent-cancel/checkout`,
    params: {},
  },
  URGENT_CANCEL_ABORT: {
    baseURL: `${BASE_CART_URL}/vms/cart/billing/urgent-cancel/abort`,
    params: {},
  },
  SNAPMINT_FAILURE_REMOVE_MEMBERSHIP: {
    baseURL: `${BASE_CART_URL}/vms/cart/billing/snapmint-failure/remove-membership/`,
    params: {},
  },
  INVOICE_REFUND_API: {
    baseURL: `${BASE_CART_URL}/vms/cart/billing/refund-invoice/`,
    params: {},
  },
  INVOICE_RETURNED_API: {
    baseURL: `${BASE_CART_URL}/vms/cart/billing/return-invoice/`,
    params: {},
  },
  SNAPMINT_PAYMENT_LINK: {
    baseURL: `${BASE_PAYMENT_URL}/v1/vms/payments/emi-whatsapp-sms/`,
    params: {},
  },
  USER_ADDRESS_LIST: {
    baseURL: `${BASE_IAM_URL}/hd/address-list/`,
    params: {},
  },
  ADDRESS_SEARCH: {
    baseURL: `${BASE_URL}/hd_orders/location/search/vms/`,
    params: {},
  },
  ADDRESS_STORE: {
    baseURL: `${BASE_URL}/clinic-org/vms/user-address/update/`,
    params: {},
  },
  ADDRESS_SELECT: {
    baseURL: `${BASE_URL}/hd_orders/location/detail/`,
    params: {},
  },
  ADDRESS_DETAIL: {
    baseURL: `${BASE_IAM_URL}/hd/address-view/`,
    params: {},
  },
  ADDRESS_UPDATE: {
    baseURL: `${BASE_IAM_URL}/hd/edit-address/`,
    params: {},
  },
  HD_CART_SEARCH: {
    baseURL: `${BASE_CART_URL}/hd/cart/search`,
    params: {},
  },
  HD_CART_ITEMS_LIST: {
    baseURL: `${BASE_CART_URL}/hd/cart/cart-items`,
    params: {},
  },
  HD_COUPONS_LIST: {
    baseURL: `${BASE_CART_URL}/hd/cart/cart-coupons`,
    params: {},
  },
  HD_DELETE_CART_ITEM: {
    baseURL: `${BASE_CART_URL}/hd/cart/delete-cart-items`,
    params: {},
  },
  HD_CART_ITEM_ADD: {
    baseURL: `${BASE_CART_URL}/hd/cart/cart-items`,
    params: {},
  },
  HD_CART_ORDER_CREATION: {
    baseURL: `${BASE_QC_URL}/v1/order/`,
    params: {},
  },
  HD_CART_PAYMENT_LINK: {
    baseURL: `${BASE_QC_URL}/v1/payment_link/`,
    params: {},
  },
  HD_WHATSAPP_SEND_REQUEST: {
    baseURL: `${BASE_VETIC_NEEV_URL}/comm/v1/whatsapp/send/`,
    params: {},
  },
  HD_WHATSAPP_TEMPLATE: {
    baseURL: `${BASE_VETIC_NEEV_URL}/comm/v1/whatsapp/template/`,
    params: {},
  },
  HD_CART_CHECKOUT: {
    baseURL: `${BASE_CART_URL}/hd/cart/checkout`,
    params: {},
  },
  HD_CART_PROCEED_PAYMENT: {
    baseURL: `${BASE_CART_URL}/hd/cart/proceed-payment`,
    params: {},
  },
  HD_ADD_ADDRESS: {
    baseURL: `${BASE_IAM_URL}/hd/vms/add-address/`,
    params: {},
  },
  HD_ADDRESS_CLUSTER_CHANGE: {
    baseURL: `${BASE_CART_URL}/vms/cart/address-cluster-change`,
    params: {},
  },
  USER_MEMBERSHIPS: {
    baseURL: `${BASE_CART_URL}/membership/cart/user-memberships`,
    params: {},
  },
  MEMBERSHIP_PITCH_DETAILS: {
    baseURL: `${BASE_CART_URL}/membership/cart/pitch-details`,
    params: {},
  },
  MEMBERSHIP_PITCH_CARDS: {
    baseURL: `${BASE_CART_URL}/membership/cart/pitch-cards`,
    params: {},
  },
  CART_GIFTS: {
    baseURL: `${BASE_CART_URL}/vms/cart/gifts`,
    params: {},
  },
  MIRROR_MEMBERSHIP_SIMULATION: {
    baseURL: `${BASE_CART_URL}/vms/cart/mirror-membership-simulation`,
    params: {},
  },
  JOB_CARD_ELIGIBILITY: {
    baseURL: `${BASE_CART_URL}/checkout/eligibility/job-card`,
    params: {},
  },
};

export const MEMBERSHIP_MODULE: VeticMembershipModuleAPIS = {
  MEMBERSHIP_LISTING_API: {
    baseURL: `${BASE_VMS_MEMBERSHIP_URL}/membership/details`,
    params: {},
  },
  MEMBERSHIP_CATEGORY_LIST: {
    baseURL: `${BASE_VMS_MEMBERSHIP_URL}/membership/category/details/`,
    params: {},
  },
  MEMBERSHIP_VMS_CATEGORY: {
    baseURL: `${BASE_URL}/clinic-org/vms/membership-category/`, // GET
    params: {},
  },
  MEMBERSHIP_CREATE: {
    baseURL: `${BASE_VMS_MEMBERSHIP_URL}/membership/`,
    params: {},
  },
  ADD_MEMBERSHIP_CATEGORY: {
    baseURL: `${BASE_VMS_MEMBERSHIP_URL}/membership/category/`,
    params: {},
  },
  MEMBERSHIP_DETAIL: {
    baseURL: `${BASE_VMS_MEMBERSHIP_URL}/membership/details`,
    params: {},
  },
  MEMBERSHIP_UPDATE: {
    baseURL: `${BASE_VMS_MEMBERSHIP_URL}/membership/`,
    params: {},
  },
  MEMBERSHIP_DISPLAY: {
    baseURL: `${BASE_VMS_MEMBERSHIP_URL}/membership/display/`,
    params: {},
  },
  MEMBERSHIP_COUPON: {
    baseURL: `${BASE_VMS_MEMBERSHIP_URL}/membership/coupons/details/`,
    params: {},
  },
  MEMBERSHIP_USAGE: {
    baseURL: `${BASE_VMS_MEMBERSHIP_URL}/membership/usage/details/`,
    params: {},
  },
  MEMBERSHIP_VISIT_DETAILS: {
    baseURL: `${BASE_VMS_MEMBERSHIP_URL}/membership/visit/details/`,
    params: {},
  },
};

export const MEMBERSHIP_EXTENSION_MODULE: VeticMembershipExtensionModuleAPIS = {
  MEMBERSHIP_EXTENSION_LISTING_API: {
    baseURL: `${BASE_VMS_MEMBERSHIP_URL}/membership_extension`,
    params: {},
  },
  MEMBERSHIP_EXTENSION_CREATE: {
    baseURL: `${BASE_VMS_MEMBERSHIP_URL}/membership_extension`,
    params: {},
  },
  MEMBERSHIP_EXTENSION_DETAIL: {
    baseURL: `${BASE_VMS_MEMBERSHIP_URL}/membership_extension/`,
    params: {},
  },
  MEMBERSHIP_EXTENSION_UPDATE: {
    baseURL: `${BASE_VMS_MEMBERSHIP_URL}/membership_extension/`,
    params: {},
  },
  MEMBERSHIP_EXTENSION_CONNECTED_MEMBERSHIPS: {
    baseURL: `${BASE_VMS_MEMBERSHIP_URL}/membership_extension/connected_memberships`,
    params: {},
  },
  MEMBERSHIP_EXTENSION_SUB_SERVICES: {
    baseURL: `${BASE_VMS_MEMBERSHIP_URL}/membership_extension/sub_services`,
    params: {},
  },
};

export const WHITELIST_MODULE: VeticWhitelistNumberModuleAPIS = {
  WHITELIST_NUMBER_: {
    baseURL: `${BASE_IAM_ORG_URL}/iam/whitelist-numbers-auth/`,
    params: {},
  },
};

export const TILES_MODULE: VeticTilesModuleAPIS = {
  TILES_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/homepage-tiles/`,
    params: {},
  },
  TILES_ONBOARD_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/homepage-tiles/draft/tiles/`,
    params: {},
  },
  TILES_VIEW_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/homepage-tiles/draft/tiles/`,
    params: {},
  },
  TILES_CONSULTATION_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/homepage-tiles/available-options/`,
    params: {},
  },
  TILES_DELETE_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/homepage-tiles/draft/tiles/`,
    params: {},
  },
  TILES_UPDATE_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/homepage-tiles/draft/tiles/`,
    params: {},
  },
  TILES_PUBLISH_API: {
    baseURL: `${BASE_URL}/clinic-org/vms/homepage-tiles/draft/tiles/`,
    params: {},
  },
};
export const PAYMENT_MODULE: VeticPaymentModuleAPIS = {
  PAYMENT_MODE_LIST: {
    baseURL: `${BASE_PAYMENT_URL}/v1/vms/payments/payment-modes`,
    params: {},
  },
  ONLINE_PAYMENT_API: {
    baseURL: `${BASE_PAYMENT_URL}/v1/vms/payments/online/`,
    params: {},
  },
  ONLINE_TO_OFFLINE_API: {
    baseURL: `${BASE_PAYMENT_URL}/v1/vms/payments/offline-switch-alert/`,
    params: {},
  },
  USER_WALLET: {
    baseURL: `${BASE_PAYMENT_URL}/v1/wallet/`,
    params: {},
  },
  USER_WALLET_TYPE: {
    baseURL: `${BASE_PAYMENT_URL}/v1/wallet/types/`,
    params: {},
  },
  TRANSACTION_HISTORY: {
    baseURL: `${BASE_PAYMENT_URL}/v1/vms/payments/payment-history/`,
    params: {},
  },
  RECORD_PAYMENT: {
    baseURL: `${BASE_PAYMENT_URL}/v1/vms/payments/settle-invoice/`,
    params: {},
  },
  CREATE_CREDIT_NOTE: {
    baseURL: `${BASE_PAYMENT_URL}/v1/notes/create-credit-note/`,
    params: {},
  },
  CREATE_DEBIT_NOTE: {
    baseURL: `${BASE_PAYMENT_URL}/v1/notes/create-debit-note/`,
    params: {},
  },
  DEBIT_NOTE_LIST: {
    baseURL: `${BASE_PAYMENT_URL}/v1/notes/debit-note/list/`,
    params: {},
  },
  DEBIT_NOTE_DETAILS: {
    baseURL: `${BASE_PAYMENT_URL}/v1/notes/debit-note/`,
    params: {},
  },
  DEBIT_NOTE_LIST_FINANCE: {
    baseURL: `${BASE_PAYMENT_URL}/v1/notes/debit-note/finance-list/`,
    params: {},
  },
  CREDIT_NOTE_LIST: {
    baseURL: `${BASE_PAYMENT_URL}/v1/notes/credit-note/list/`,
    params: {},
  },
  SINGLE_CREDIT_NOTE: {
    baseURL: `${BASE_PAYMENT_URL}/v1/notes/credit-note/`,
    params: {},
  },
  DEBIT_REJECT_APPROVE: {
    baseURL: `${BASE_PAYMENT_URL}/v1/notes/update-debit-note/`,
    params: {},
  },
  DEBIT_LIST_STATUS_API: {
    baseURL: `${BASE_PAYMENT_URL}/v1/notes/status-list/`,
    params: {},
  },
  REFUND_REQUEST_LIST_API: {
    baseURL: `${BASE_PAYMENT_URL}/v1/notes/refund-request/list/`,
    params: {},
  },
  REFUND_REQUEST_APPROVE_REJECTED: {
    baseURL: `${BASE_PAYMENT_URL}/v1/notes/create-refund-note/`,
    params: {},
  },

  SINGLE_REFUND_REQUESTED_NOTE: {
    baseURL: `${BASE_PAYMENT_URL}/v1/notes/refund-request/`,
    params: {},
  },
  PAYMENT_DETAILS: {
    baseURL: `${BASE_PAYMENT_URL}/v1/vms/payments/change-payment-mode/`,
    params: {},
  },
  PAYMENT_MODE_CHANGE: {
    baseURL: `${BASE_PAYMENT_URL}/v1/vms/payments/change-payment-mode/`,
    params: {},
  },
  USER_UNSETTLED_DETAILS_API: {
    baseURL: `${BASE_PAYMENT_URL}/v1/wallet/unsettled/`,
    params: {},
  },
  FINANCE_SUMMARY_API: {
    baseURL: `${BASE_PAYMENT_URL}/v1/vms/payments/financial-summary/`,
    params: {},
  },
  ADVANCE_COLLECTION_ELIGIBILITY: {
    baseURL: `${BASE_PAYMENT_URL}/v1/wallet/advanced-collection-eligibility/`,
    params: {},
  },
  INVOICE_ADJUSTMENT_SUMMARY: {
    baseURL: `${BASE_PAYMENT_URL}/v1/vms/payments/invoice-adjustments/summary`,
    params: {},
  },
  INVOICE_ADJUSTMENT_UPLOAD: {
    baseURL: `${BASE_PAYMENT_URL}/v1/vms/payments/invoice-adjustments/upload`,
    params: {},
  },
 
  INVOICE_ADJUSTMENT_REQUESTS: {
    baseURL: `${BASE_PAYMENT_URL}/v1/vms/payments/invoice-adjustments/requests`,
    params: {},
  },
};

export const LAB_REPORT: VeticLabReportListAPIS = {
  STATUS_LIST: {
    baseURL: `${BASE_URL}/lab-test/lab-report-status/`,
    params: {},
  },
  UPLOAD_LAB_REPORT: {
    baseURL: `${BASE_URL}/lab-management/lab-report/upload-report/`,
    params: {},
  },
  LAB_REPORT_DETAILS: {
    baseURL: `${BASE_URL}/lab-test/requisitions/detail/`,
    params: {},
  },
  REQUEST_SAMPLE_API: {
    baseURL: `${BASE_URL}/lab-test/request-sample/`,
    params: {},
  },
  LAB_REPORT_ESCALATION: {
    baseURL: `${BASE_URL}/lab-test/lab-report-escalation/`,
    params: {},
  },
  LAB_REPORT_DOCUMENT_UPLOAD: {
    baseURL: `${BASE_URL}/lab-test/upload-labreport-documents/`,
  },
  // LAB_REPORT_FILTER_LIST: {
  //   baseURL: `${BASE_URL}/lab-test/labtest-requisitions/`,
  //   params: {},
  // },
  LAB_REPORT_FILTER_LIST: {
    baseURL: `${BASE_URL}/lab-management/lab-report-list/`,
    params: {},
  },
  // LAB_REPORT_STATS_LIST: {
  //   baseURL: `${BASE_URL}/lab-test/labtest-requisitions-stats/`,
  //   params: {},
  // },
  LAB_REPORT_STATS_LIST: {
    baseURL: `${BASE_URL}/lab-management/lab-report-stats/`,
    params: {},
  },
  LAB_REPORT_INTERPRETATION_LIST: {
    baseURL: `${BASE_URL}/lab-interpretation/vms/list/`,
    params: {},
  },
  LAB_REPORT_INTERPRETATION_PET_LIST: {
    baseURL: `${BASE_URL}/lab-interpretation/vms/pet/list/`,
    params: {},
  },
  LAB_REPORT_INTERPRETATION_COUNTS: {
    baseURL: `${BASE_URL}/lab-interpretation/vms/counts/`,
    params: {},
  },
  LAB_REPORT_INTERPRETATION_PENDING_REQUISITIONS: {
    baseURL: `${BASE_URL}/lab-interpretation/vms/v1/emr/pending-requisitions/`,
    params: {},
  },
  LAB_REPORT_INTERPRETATION_EMR_CREATE: {
    baseURL: `${BASE_URL}/lab-interpretation/vms/v1/emr/create/`,
    params: {},
  },
  LAB_REPORT_INTERPRETATION_EMR_DETAIL: {
    baseURL: `${BASE_URL}/lab-interpretation/vms/v1/emr/detail/`,
    params: {},
  },
  LAB_REPORT_INTERPRETATION_EMR_UPDATE: {
    baseURL: `${BASE_URL}/lab-interpretation/vms/v1/emr/update/`,
    params: {},
  },
  LAB_REPORT_INTERPRETATION_ALERTS_STREAM: {
    baseURL: `${BASE_QC_URL}/vms/lri-alerts/stream/`,
    params: {},
  },
  LAB_PARTNER_ONBOARDING: {
    baseURL: `${BASE_URL}/lab-management/onboard-lab-partner/`,
    params: {},
  },
  LAB_PARTNER_UPDATE: {
    baseURL: `${BASE_URL}/lab-management/update-lab-partner/`,
    params: {},
  },
  LAB_PARTNER_DETAILS: {
    baseURL: `${BASE_URL}/lab-management/lab-details/`,
    params: {},
  },
  LAB_PARTNER_LIST: {
    baseURL: `${BASE_URL}/lab-management/lab-list/`,
    params: {},
  },
  LAB_TEST_LIST: {
    baseURL: `${BASE_URL}/lab-management/labtest/`,
    params: {},
  },
  SEARCH_LAB_PARTNER: {
    baseURL: `${BASE_URL}/lab-management/search-lab-partner/`,
    params: {},
  },
  ADD_LAB_PARTNER_NAME: {
    baseURL: `${BASE_URL}/lab-management/add-lab-partner/`,
    params: {},
  },
  LAB_PARTNER_DROPDOWN: {
    baseURL: `${BASE_URL}/lab-management/lab-partners/`,
    params: {},
  },
  CLINIC_LAB_MAPPING: {
    baseURL: `${BASE_URL}/lab-management/update-clinic-lab-mapping/`,
    params: {},
  },
  LAB_MANAGEMENT_REQUISITION: {
    baseURL: `${BASE_URL}/lab-management/requisition/`,
    params: {},
  },
  TRF_GENERATE: {
    baseURL: `${BASE_URL}/lab-management/lab-report/`,
    params: {},
  },
  TRF_UPDATE: {
    baseURL: `${BASE_URL}/lab-management/lab-report/generate-trf/`,
    params: {},
  },
  GENERATE_VIAL_BARCODE: {
    baseURL: `${BASE_URL}/lab-management/lis/v1/generate-barcode`, // GET
    params: {},
  },
  LAB_UPDATE: {
    baseURL: `${BASE_URL}/lab-management/requisition/`,
    params: {},
  },
  LAB_DETAILS: {
    baseURL: `${BASE_URL}/lab-management/requisition/`,
    params: {},
  },
  LAB_REPORT_REJECT_REPORT: {
    baseURL: `${BASE_URL}/lab-management/lab-report/reject-report/`,
    params: {},
  },
  LAB_REPORT_RETEST: {
    baseURL: `${BASE_URL}/lab-management/lab-report/retest/`,
    params: {},
  },
  LAB_REPORT_RETEST_ENQUEUE: {
    baseURL: `${BASE_URL}/lab-management/lab-report/retest-enqueue/`,
    params: {},
  },
  LAB_REPORT_RETEST_REASONS: {
    baseURL: `${BASE_URL}/lab-management/retest-reasons/`,
    params: {},
  },
  LAB_REPORT_TRF_DELETE_REASONS: {
    baseURL: `${BASE_URL}/lab-management/trf-delete-reasons/`,
    params: {},
  },
  LAB_REPORT_LAB_CHANGE_REASONS: {
    baseURL: `${BASE_URL}/lab-management/lab-change-reasons/`,
    params: {},
  },
  LAB_REPORT_EXTERNAL_EXEMPTION: {
    baseURL: `${BASE_PAYMENT_URL}/v1/day-closing/operations/reconciliation/external_lab_reports`,
    params: {},
  },
  LAB_REPORT_TRF_REJECT_REASON_LIST: {
    baseURL: `${BASE_URL}/lab-management/rejection-reasons/`,
    params: {},
  },
};

export const CERTIFICATE_MODULE: VeticCertificateDocumentModuleAPIS = {
  DOCUMENT_LIST: {
    baseURL: `${BASE_URL}/clinic-org/vms/user-pet-documents/`,
    params: {},
  },
  DOCUMENT_UPLOAD: {
    baseURL: `${BASE_VETIC_NEEV_URL}/certificate/vms`,
    params: {},
  },
  DOCUMENT_DETAIL: {
    baseURL: `${BASE_URL}/clinic-org/vms/user-pet-documents/`,
    params: {},
  },
  DOCUMENT_DELETE: {
    baseURL: `${BASE_URL}/clinic-org/vms/user-pet-documents/`,
    params: {},
  },
  DOCUMENT_UPDATE: {
    baseURL: `${BASE_URL}/clinic-org/vms/user-pet-documents/`,
    params: {},
  },
};

export const TOOLS_MODULE: VeticToolsModuleAPIS = {
  CALL_ANALYSIS: {
    baseURL: `${BASE_VETIC_NEEV_URL}/tools/v1/call-analysis/`,
    params: {},
  },
};
